module.exports = __webpack_public_path__ + "static/img/pic2.cb4fa73.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/about/A09_lxwm/pic2.png
// module id = 7EkI
// module chunks = 0